import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import "../../styles/filesComponent.pc.css";
import "../../styles/widjets.pc.css";
import "./nameProject.pc.css";
import "./nameProject.pc.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import { Context } from "../../../index";
import { Link, useNavigate, useParams } from "react-router-dom";
import CopyTextButton from "../../buttons/CopyTextButton/CopyTextButton";
import { AppContext } from "../../../App";
import InputSaveOnEdit from "../InputSaveOnWidjet/InputSaveOnWidjet";
import AddEditProject from "../../Shared/AddEditProject/AddEditProject";
import BtnAdd from "../../buttons/btnAdd.component/BtnAdd";
import ConfirmationWindow from "../../Shared/ConfirmationWindow/ConfirmationWindow";
import EditPointsBlue from "../../../assets/moreGray.svg";
import EditPointsGray from "../../../assets/editPontsGray.svg";
import { IFunctionPermissions } from "../../../common/api_interfaces/role/IFunctionPermissions";
import Loader from "../../Shared/Loader/Loader";
import { CurrentTab, TabNavigator } from "../../UiLib/TabNavigator/TabNavigator";
import { hasPermission } from "../../../helpers/hasPermisson";
import { ProjectContext } from "../../../pages/Project/Project";
import type { IUnarchiveProjects } from "../../../common/api_interfaces/archive/IUnarchiveProjects";
import { IProjectGeneralInfo } from "../../../common/api_interfaces/project/IProjectGeneralInfo";
import { IProjectDeleteReq } from "../../../common/api_interfaces/project/IProjectDeleteReq";
import { BoardWithRestrictAccess } from "../../../common/api_interfaces/board/IRestrictBoardView";
import { IProjectCreateReq } from "../../../common/api_interfaces/project/IProjectCreateReq";

interface IProjectNameProps {
    data: IProjectGeneralInfo | undefined;
    loadNameProjectData: () => void;
    userAccess: IFunctionPermissions[];
}

export const NameProjectContext = createContext<any>(null);

const dataForEdit = ["Отредактировать проект", "Добавить в архив", "Восстановить из архива", "Удалить проект"];

const NameProject: React.FC<IProjectNameProps> = ({ data, loadNameProjectData, userAccess }) => {
    const { store } = useContext(Context);
    const { getData, showToast, archivedPage } = useContext(AppContext);
    const { projectSettings } = useContext(ProjectContext);
    const [open, setOpen] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const [openInputProject, setOpenInputProject] = useState(false);
    const [openInputBoard, setOpenInputBoard] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);
    const [valueProj, setValueProj] = useState("");
    const [valueBoard, setValueBoard] = useState("");
    const [openConfirmWindow, setOpenConfirmWindow] = useState(false);
    const [openOnFullWindow, setOpenOnFullWindow] = useState(false);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [headerText, setHeaderText] = useState("");
    const [bodyText, setBodyText] = useState("");

    const [deleteFunction, setDeleteFunction] = useState(false);
    const [archiveFunction, setArchiveFunction] = useState(false);

    // Ограничение прав
    const editProject = useMemo(() => hasPermission(userAccess, "ProjectAction", "edit"), [userAccess]);
    const archiveProject = useMemo(() => hasPermission(userAccess, "ArchiveAction", "edit"), [userAccess]);
    const addBoard = useMemo(() => hasPermission(userAccess, "BoardAction", "create"), [userAccess]);
    const addSubProject = useMemo(() => hasPermission(userAccess, "SubProjectAction", "create"), [userAccess]);
    const delProject = useMemo(() => hasPermission(userAccess, "ProjectAction", "delete"), [userAccess]);
    const viewBoards = useMemo(() => hasPermission(userAccess, "BoardAction", "view"), [userAccess]);

    //Доступ к борде
    const [allBoardProject, setAllBoardProject] = useState<BoardWithRestrictAccess[]>();
    const [showLoader, setShowLoader] = useState<boolean>(false);

    const [nameError, setNameError] = useState<string>();

    useEffect(() => {
        const keyDownHandler = (event: any) => {
            if (event.key === "Escape") {
                event.preventDefault();
                setOpenInputProject(false);
                setOpenInputBoard(false);
            }
        };
        document.addEventListener("keydown", keyDownHandler);
        // Clean up event listener
        return () => {
            document.removeEventListener("keydown", keyDownHandler);
        };
    }, []);

    const getBoardNameProject = useCallback(async () => {
        try {
            // Проверяем, что currentProjectId является числом
            if (isNaN(store.currentProjectId) || isNaN(Number(id))) {
                console.error("Не найден id проекта!");
                return;
            }

            // Получаем данные о доске
            const boardData = await store.restrictAccess(
                isNaN(store.currentProjectId) ? Number(id) : store.currentProjectId
            );

            // Проверяем, что данные получены
            if (!boardData) {
                return;
            }

            // Находим роли текущего пользователя
            const personsRolesIds = boardData.person
                .filter((person) => person.email === store.user.email)
                .map((person) => person.personRoleId);

            // Фильтруем доски, к которым у пользователя нет доступа
            const chekBoard = boardData.boards.filter((board) => {
                return (
                    viewBoards || !board.personRoleIds?.some((personRoleId) => personsRolesIds.includes(personRoleId))
                );
            });

            // Устанавливаем отфильтрованные доски
            setAllBoardProject(chekBoard);
        } catch (error) {
            console.error("Ошибка при получении данных о доске:", error);
        }
    }, [store.currentProjectId, store.user.email, store.restrictAccess, setAllBoardProject, viewBoards]);

    useEffect(() => {
        getBoardNameProject()
            .then()
            .catch((r) => console.error("Ошибка при получении данных о доске", r));
    }, [getBoardNameProject, userAccess, data, projectSettings]);

    function onAddClick() {
        if (activeIndex === 2) {
            if (addBoard) {
                if (store.getAvailableModules().multiBoards === false && (data?.boards?.length ?? 0) >= 1) {
                    showToast("У вас нет лицензии на мульти-доски!");
                } else if (
                    store.getAvailableModules().multiBoards === true &&
                    (data?.boards?.length ?? 0) >= store.getUpgradeCount().multiBoards
                ) {
                    showToast(`Вы достигли лимита в ${store.getUpgradeCount().multiBoards} мульти-досок!`);
                } else setOpenInputBoard(true);
            } else {
                showToast("У вас нет прав для создания доски!");
            }
        } else if (activeIndex === 1) {
            if (addSubProject) {
                setOpenInputProject(true);
            } else {
                showToast("У вас нет прав для создания проекта!");
            }
        }
    }

    function onEditClick(e: any) {
        setOpen(false);
        if (e.target.innerText === "Добавить в архив") {
            if (archiveProject) {
                setHeaderText("Архивирование проекта");
                setBodyText("Вы уверены, что хотите добавить проект в архив?");
                setArchiveFunction(true);
                setOpenConfirmWindow(true);
            } else {
                showToast("У вас нет прав для добавления в архив!");
            }
        } else if (e.target.innerText === "Восстановить из архива") {
            if (archiveProject) {
                setHeaderText("Восстановление проекта");
                setBodyText("Вы уверены, что хотите восстановить проект?");
                setArchiveFunction(true);
                setOpenConfirmWindow(true);
            } else {
                showToast("У вас нет прав для восстановления из архива!");
            }
        } else if (e.target.innerText === "Отредактировать проект") {
            if (editProject) {
                setActiveIndex(0);
                setOpenEdit(true);
            } else {
                showToast("У вас нет прав для редактирования проекта!");
            }
        } else if (e.target.innerText === "Удалить проект") {
            if (delProject) {
                setHeaderText("Удаление проекта");
                setBodyText("Вы уверены, что хотите удалить проект?");
                setDeleteFunction(true);
                setOpenConfirmWindow(true);
            } else {
                showToast("У вас нет прав для удаления проекта!");
            }
        }
    }

    function saveBoard(e: any) {
        setShowLoader(true);
        if (validateName(valueBoard.trim(), "Наименование доски должно содержать хотябы 1 символ")) {
            setShowLoader(false);
            return;
        }
        e.preventDefault();
        id &&
            (async () => {
                try {
                    await store.addDashBoard(valueBoard.trim(), Number(id));
                    loadNameProjectData();
                    await getData();
                    setValueBoard("");
                    setOpenInputBoard(false);
                    getBoardNameProject();
                    showToast("Канбан доска создана");
                    setShowLoader(false);
                } catch (e) {
                    showToast(`Произошла ошибка! ${e}`);
                    setShowLoader(false);
                }
            })();
    }

    const saveProject = async () => {
        setShowLoader(true);
        if (
            validateName(
                valueProj.trim(),
                "Наименование подпроекта должно содержать хотябы 1 символ и не может быть больше 30 символов"
            )
        ) {
            setShowLoader(false);
            return;
        }
        if (id) {
            const body: IProjectCreateReq = {
                name: valueProj.trim(),
                parentProjectId: Number(id),
                description: "",
                startDate: new Date().toISOString(),
                endDate: new Date().toISOString(),
                photoId: null,
                abbreviation: valueProj.trim().length >= 3 ? valueProj.trim().slice(0, 3) : data!.abbreviation,
            };

            try {
                await store.createProject(body);
                await loadNameProjectData();
                await getData();
                setValueProj("");
                setOpenInputProject(false);
                showToast("Подпроект создан");
                setShowLoader(false);
            } catch (e) {
                showToast(`Произошла ошибка! ${e}`);
                setShowLoader(false);
            }
        }
    };

    const onDelete = async () => {
        let body: IProjectDeleteReq = {
            projectId: Number(id),
        };
        await store.deleteProject(body);
        await getData();
        showToast("Проект удален");
    };

    const onArchive = async () => {
        await store.archiveProject(Number(id));
        await getData();
        showToast("Проект заархивирован");
    };

    const onUnarchiveProjects = async () => {
        let projectId: number[] = [Number(id)];
        let body: IUnarchiveProjects = {
            projectIds: projectId,
        };
        await store.unarchiveProjects(body);
        await getData();
        showToast("Проект разархивирован");
    };

    const onConfirm = async () => {
        if (deleteFunction) {
            await onDelete();
        } else if (archiveFunction && data && data.isArchived) {
            await onUnarchiveProjects();
        } else if (archiveFunction && data && !data.isArchived) {
            await onArchive();
        }
        setOpenConfirmWindow(false);
        navigate("/projects");
    };
    const onCancel = () => {
        setOpenConfirmWindow(false);
        setArchiveFunction(false);
        setDeleteFunction(false);
    };

    const handleEditProject = async () => {
        loadNameProjectData();
    };

    const reroute = () => {
        navigate("/projects");
    };

    const checkStyleArchive = (element: string) => {
        return element.includes("далить") && data?.isArchived === false
            ? { color: "rgb(186, 78, 65)" }
            : element.includes("далить") && data?.isArchived === true
            ? { display: "none" }
            : element.includes("Отредактировать") && data?.isArchived === true
            ? { display: "none" }
            : element.includes("Добавить в архив") && store.getAvailableModules().archive !== true
            ? { display: "none" }
            : element.includes("Добавить в архив") && data?.isArchived === true
            ? { display: "none" }
            : element.includes("Добавить в архив") && (data?.parentProjectId ?? undefined) !== undefined
            ? { display: "none" }
            : element.includes("Восстановить из архива") && data?.isArchived === false
            ? { display: "none" }
            : element.includes("Восстановить из архива") && (data?.parentProjectId ?? undefined) !== undefined
            ? { display: "none" }
            : {};
    };

    const validateName = (name: string, errorString: string): boolean => {
        let nameErr = undefined;

        if (!name || !name.trim().length) {
            nameErr = errorString;
        }

        setNameError(nameErr);
        return nameErr !== undefined;
    };

    return (
        <NameProjectContext.Provider value={{ getBoardNameProject }}>
            {showLoader && <Loader />}
            <div className={openOnFullWindow ? "widget_wrapper--full__window" : "widget_wrapper"}>
                <div className={openOnFullWindow ? "widget_wrapper-full__window--block" : "widget_wrapper_block"}>
                    {openConfirmWindow && (
                        <ConfirmationWindow
                            headerText={headerText}
                            bodyText={bodyText}
                            confirmText="Да"
                            cancelText="Нет"
                            onConfirm={onConfirm}
                            onCancel={onCancel}
                        />
                    )}
                    {openEdit && (
                        <AddEditProject
                            projectSetting={projectSettings}
                            setOpen={setOpenEdit}
                            projectInfo={
                                data
                                    ? {
                                          name: data.projectName,
                                          description: data.description,
                                          startDate: data.startDate,
                                          endDate: data.endDate,
                                          photoId: data.photoId,
                                          abbreviation: data.abbreviation,
                                      }
                                    : undefined
                            }
                            onAction={handleEditProject}
                            editSubproject={data?.parentProjectId !== null}
                        />
                    )}
                    <div className="widgets_header">
                        <div className="widjets_header_left">
                            <h2 className="widget-card-header-style" onLoad={data ? reroute : undefined}>
                                {data?.projectName}
                            </h2>
                        </div>
                        <div className="widjets_header_rigth">
                            {activeIndex === 0 ? (
                                <div className="widjets_header_rigth--modal">
                                    <div className="widjets_header_rigth--modal__edit">
                                        <button
                                            onClick={() =>
                                                editProject || delProject || archiveProject
                                                    ? setOpenModalEdit(!openModalEdit)
                                                    : showToast("У вас нет прав для редактирования проекта!")
                                            }
                                        >
                                            <img
                                                className="widjets_header_rigth--modal__edit--img"
                                                src={
                                                    editProject || delProject || archiveProject
                                                        ? EditPointsBlue
                                                        : EditPointsGray
                                                }
                                            />
                                        </button>
                                    </div>
                                    {openModalEdit ? (
                                        <div>
                                            <div
                                                className="widjets_header_rigth--modal__window"
                                                onMouseLeave={() => setOpenModalEdit(!openModalEdit)}
                                            >
                                                {dataForEdit.map((element) => (
                                                    <button
                                                        onClick={(e: any) => onEditClick(e)}
                                                        style={checkStyleArchive(element)}
                                                    >
                                                        {element}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            ) : (
                                <BtnAdd
                                    type={""}
                                    onClickFunc={() => onAddClick()}
                                    permission={
                                        activeIndex === 2
                                            ? addBoard === true &&
                                              (store.getAvailableModules().multiBoards === true
                                                  ? (data?.boards?.length ?? 0) < store.getUpgradeCount().multiBoards
                                                  : (data?.boards?.length ?? 0) < 1)
                                            : addSubProject
                                    }
                                />
                            )}
                        </div>
                    </div>
                    <div className="nameProj-sub-header">
                        <p id="general-info-widget-project-number" className="nameProj_p_11_sub_header_widgets">
                            {data?.number}
                        </p>
                        <CopyTextButton
                            title={"Скопировать номер проекта"}
                            titlePosition={"right"}
                            textDivId="general-info-widget-project-number"
                        />
                    </div>
                    <div className="nameProj_body">
                        <TabNavigator classBlock={"nameProj-body-navigator"}>
                            <CurrentTab name={"Описание"} callBack={() => setActiveIndex(0)}>
                                <div className="nameProj-body-navigator-block">
                                    <p
                                        className="m-0"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "0px",
                                            overflowY: "auto",
                                            wordBreak: "break-word",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {data?.description}
                                    </p>
                                </div>
                            </CurrentTab>
                            {!data?.parentProjectId ? (
                                <CurrentTab
                                    disabled={data?.parentProjectId !== undefined && data?.parentProjectId !== null ? true : false}
                                    name={"Подпроекты"}
                                    callBack={() => {
                                        setActiveIndex(1);
                                        setNameError(undefined);
                                    }}
                                >
                                    <div className="nameProj-body-navigator-block">
                                        <div
                                            style={{
                                                margin: "0px",
                                                height: "100%",
                                            }}
                                        >
                                            <div className="board-subprojects-container">
                                                <InputSaveOnEdit
                                                    value={valueProj}
                                                    setValue={setValueProj}
                                                    open={openInputProject}
                                                    setOpen={setOpenInputProject}
                                                    save={saveProject}
                                                    typeInput="text"
                                                    validationErr={nameError}
                                                />
                                                {data?.childProjects?.map((item, index) => (
                                                    <div
                                                        key={item.id}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            padding: "5px",
                                                        }}
                                                    >
                                                        <Link
                                                            to={`${archivedPage ? "/archive" : ""}/project/${item.id}`}
                                                        >
                                                            {item.name}
                                                        </Link>
                                                        <div
                                                            className="endData"
                                                            style={{
                                                                marginLeft: "auto",
                                                                display: "flex",
                                                                flexDirection: "row",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: "5px",
                                                                }}
                                                            >
                                                                Доски: {item.boardCount}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "5px",
                                                                }}
                                                            >
                                                                Задачи: {item.taskCount}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </CurrentTab>
                            ) : null}
                            <CurrentTab
                                name={"Канбан доски"}
                                callBack={() => {
                                    setActiveIndex(2);
                                    setNameError(undefined);
                                }}
                            >
                                <div className="nameProj-body-navigator-block">
                                    <div
                                        style={{
                                            margin: "0px",
                                            height: "100%",
                                        }}
                                    >
                                        <div className="board-subprojects-container">
                                            <InputSaveOnEdit
                                                value={valueBoard}
                                                setValue={setValueBoard}
                                                open={openInputBoard}
                                                setOpen={setOpenInputBoard}
                                                save={saveBoard}
                                                typeInput="text"
                                                validationErr={nameError}
                                            />
                                            {data?.boards?.map((item, index) => (
                                                <div
                                                    key={item.id}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        padding: "5px",
                                                    }}
                                                >
                                                    {allBoardProject?.map((xx) => xx.id).includes(item.id) ? (
                                                        <Link to={`${archivedPage ? "/archive" : ""}/board/${item.id}`}>
                                                            {item.name}
                                                        </Link>
                                                    ) : (
                                                        <div
                                                            onClick={() => {
                                                                showToast("У вас нет доступа к этой доске!");
                                                            }}
                                                        >
                                                            {item.name}
                                                        </div>
                                                    )}
                                                    <div
                                                        className="endData"
                                                        style={{
                                                            marginLeft: "auto",
                                                            display: "flex",
                                                            flexDirection: "row",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                padding: "5px",
                                                            }}
                                                        >
                                                            Задачи: {item.taskCount}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </CurrentTab>
                        </TabNavigator>
                    </div>
                </div>
            </div>
        </NameProjectContext.Provider>
    );
};

export default observer(NameProject);
